<script>
import { required, minLength,numeric, requiredIf, url  } from "vuelidate/lib/validators";
import Content from '@/services/Content';
import BusinessNewsAudienceTargeting from '@/components/business/BusinessNewsAudienceTargeting';
import Swal from "sweetalert2";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import ClassicEditor from '@/ckeditor/ckeditor.js';
import validationMessages from '@/components/validations'
import Sortable from 'sortablejs';
import moment from 'moment';
import {
  buildDefaultFieldAttributes,
  normalizeAdditionalFieldsForApi,
  validateAdditionalSections,
  detectParamInputType,
} from '@/helpers/businessEventFieldAttributes';


export default {
  components: {
    flatPickr,
    validationMessages,
    BusinessNewsAudienceTargeting,
    ckeditor: CKEditor.component,
  },
  props: {
    data: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
        news_id: "",
        submitted: false,
        showModal: false,
        tryingToEdit: false,
        image_removed: false,
        title: "",
        original_content: "",
        image: "",
        file:null,
        content_type: "event",
      editorConfig: {
        toolbar: [
          'heading', '|',
          'alignment',          // ← add this
          'bold', 'italic',     // basic styles
          'link',               // link button
          '|',
          'bulletedList', 'numberedList',
          'blockQuote',
          '|',
          'undo', 'redo',
        ],
      },
        event_info: {
          start_at:null,
          register_by: null,
          registrationLimit: null,
          userLimit: null,
          companyLimit: null,
          location: '',
          toc: '',
          external_registration: 0,
          external_registration_url: '',
        },
        externalRegistration: false,
        date: '',
        time: '',
        registerByDate: '',
        registerByTime: '',
        isPopulatingFields: false,
        published: '',
        publishedDate: '',
        publishedTime: '',
        timeconfig: {
          enableTime: true,
          noCalendar: true,
          time_24hr: true,
          minuteIncrement: 1,
          dateFormat: "H:i",
        },
        publishedDateconfig: {
          enableTime: false,
          dateFormat: "Y-m-d",
        },
        publishedTimeconfig: {
          enableTime: true,
          noCalendar: true,
          time_24hr: true,
          minuteIncrement: 1,
          dateFormat: "H:i",
        },
        editor: ClassicEditor,
        csrf_token: localStorage.getItem('csrf_token'),
        verified_checked : false,
        accepted_file_types: ['image/jpeg', 'image/png','image/gif','image/webp','image/bmp'],
        accepted_file_size:'4096',
        acceptedFileTypeErrorMessage:'',
        acceptedFileTypeError:false,
        acceptedFileSizeErrorMessage:'',
        acceptedFileSizeError:false,
        fields_definition:{},
        additional_field_options:[],
        field_type:'',
        show_select_field_type: false,
        sectionIdCounter: 0,
        additional_sections: [],
        showCheckedIcon:false,
        showNotCheckedIcon:true,
        isDragOver: false,
        savedSections: [],
        sortableInstance: null,
        initialLabelIds: [],
        initialGroupIds: [],
    };


  },

      validations() {
        return {
          title: { required },
          original_content: { required },
          image: { required },
          published: { required },
          event_info: {
            start_at: { required },
            registrationLimit: { numeric },
            // userLimit: { numeric },
            // companyLimit: { numeric },
            location: { required },
            // toc: { required, url },
            external_registration_url: {
              required: requiredIf(function () { return this.externalRegistration; }),
              url,
            },
          },
          additional_sections: {
           $each: {
             field_type: { required: requiredIf(function () { return !this.externalRegistration && this.show_select_field_type }) },
        //     name: { required: requiredIf(function () { return this.show_select_field_type }) },
             label: { required: requiredIf(function () { return !this.externalRegistration && this.show_select_field_type }) }
           }
          }
        };
      },

     watch: {
       field_type: function(newType) {
           if (!newType) return;
           const def = this.fields_definition[newType];
           if (def && def.required_params) {
             const params = JSON.parse(def.required_params);
             this.field_attributes = {};
             params.forEach(p => {
               this.field_attributes[p.param] = p.param_type === "array" ? [""] : "";
             });
           }
         },
       date() {
         this.updateStartAt();
         if (this.isPopulatingFields) {
           return;
         }
         this.syncRegisterByWithEventDate();
       },
       time() {
         this.updateStartAt();
         if (this.isPopulatingFields) {
           return;
         }
         if (this.registerByDate && this.registerByDate === this.date) {
           this.registerByTime = this.time || '';
           this.updateRegisterBy();
         }
       },
       registerByDate() {
         if (this.isPopulatingFields) {
           return;
         }
         this.updateRegisterBy();
       },
       registerByTime() {
         if (this.isPopulatingFields) {
           return;
         }
         this.updateRegisterBy();
       },
       publishedDate() {
         this.updatePublished();
       },
       publishedTime() {
         this.updatePublished();
       },
       externalRegistration(isExternal) {
         this.event_info.external_registration = isExternal ? 1 : 0;
         if (isExternal) {
           return;
         }
         this.event_info.external_registration_url = '';
         this.ensureAdditionalFieldsReady();
       },
     },

     computed: {
       dateconfig() {
         const today = new Date();
         today.setHours(0, 0, 0, 0);
         let minDate = today;
         if (this.date) {
           const existing = new Date(`${this.date}T00:00:00`);
           if (!Number.isNaN(existing.getTime()) && existing < today) {
             minDate = existing;
           }
         }
         return {
           enableTime: false,
           dateFormat: 'Y-m-d',
           minDate,
         };
       },
       registerByDateConfig() {
         const today = new Date();
         today.setHours(0, 0, 0, 0);
         let minDate = today;
         if (this.registerByDate) {
           const existing = new Date(`${this.registerByDate}T00:00:00`);
           if (!Number.isNaN(existing.getTime()) && existing < today) {
             minDate = existing;
           }
         }
         return {
           enableTime: false,
           dateFormat: 'Y-m-d',
           minDate,
           maxDate: this.date || null,
         };
       },
       validationErrors() {
         const errors = [];
         const v = this.$v || {};
         if (v.title && v.title.$invalid) errors.push('Event Name is required.');
         if (v.original_content && v.original_content.$invalid) errors.push('Content is required.');
         if (v.published && v.published.$invalid) errors.push('Published Date is required.');
         // Event fields (edit modal uses event_info)
         if (v.event_info && v.event_info.start_at && v.event_info.start_at.$invalid) errors.push('Date and Time is required.');
         if (v.event_info && v.event_info.location && v.event_info.location.$invalid) errors.push('Location is required.');
         // if (v.event_info && v.event_info.toc && v.event_info.toc.$invalid) errors.push('Terms and Conditions is required.');
         if ((this.registerByDate && !this.registerByTime) || (!this.registerByDate && this.registerByTime)) {
           errors.push('Register By requires both date and time.');
         }
         if (this.event_info.register_by && this.event_info.start_at) {
           const registerByTs = moment(this.event_info.register_by, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD']);
           const startAtTs = moment(this.event_info.start_at, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD']);
           if (registerByTs.isValid() && startAtTs.isValid() && registerByTs.isAfter(startAtTs)) {
             errors.push('Register By must be before or equal to the event date/time.');
           }
         }
         if (this.externalRegistration) {
           if (v.event_info && v.event_info.external_registration_url && v.event_info.external_registration_url.$invalid) {
             errors.push(
               !this.event_info.external_registration_url
                 ? 'External Registration URL is required.'
                 : 'External Registration URL must be a valid URL.'
             );
           }
         } else {
           // numeric fields
           // if (v.event_info && v.event_info.userLimit && v.event_info.userLimit.$invalid) errors.push('User Limit must be a number.');
           // if (v.event_info && v.event_info.companyLimit && v.event_info.companyLimit.$invalid) errors.push('Company Limit must be a number.');
           if (v.event_info && v.event_info.registrationLimit && v.event_info.registrationLimit.$invalid) errors.push('Event Limit must be a number.');

           if(this.showCheckedIcon){
               errors.push(...validateAdditionalSections(this.additional_sections, this.fields_definition));
           }
         }
         return errors;
       }
     },

  methods: {
    async editBusinessEvent() {
      if(this.acceptedFileTypeError || this.acceptedFileSizeError) return;
      this.tryingToEdit = true;
      this.$v.$touch();

      const now = new Date();
      const selectedDate = new Date(this.event_info.start_at);
      if (!this.event_info.start_at || selectedDate <= now) {
        this.tryingToEdit = false;
        this.failedmsg("Please choose a date in the future");
        return;
      }

      if (this.$v.$invalid || this.validationErrors.length) {
        this.tryingToEdit = false;
        this.submitted = true;
        if (this.validationErrors.length) {
          this.failedmsg(this.validationErrors[0]);
        }
        return;
      }

      const audienceError = this.$refs.audienceTargeting.validate();
      if (audienceError) {
        this.failedmsg(audienceError);
        this.tryingToEdit = false;
        return;
      }

      this.csrf_token = localStorage.getItem('csrf_token') || '';
      const formData = new FormData();
      formData.append("title", this.title);
      formData.append("original_content", this.original_content);
      formData.append("active", this.verified_checked == true ? 1 : 0);
      formData.append('_method', 'PATCH')

      if (this.file) {
        formData.append("image", this.file);
      }


      formData.append("csrf_token", this.csrf_token);
      formData.append("content_type", this.content_type);
      formData.append("published", this.published);

      // Filter additional sections to only include saved/valid ones
      let validAdditionalFields = [];
      if (this.show_select_field_type && this.additional_sections.length > 0) {
        validAdditionalFields = this.additional_sections
          .filter((section, index) => {
            // Only include sections that are saved AND have valid data
            return this.savedSections[index] === true && 
                   section.field_type && 
                   section.label && 
                   section.label.trim() !== '';
          })
          .map(section => ({
            field_id: section.field_id || '',
            field_type: section.field_type,
            name: section.name || '',
            label: section.label,
            required: section.required || 0,
            field_attributes: section.field_attributes || {}
          }));
      }

      const eventData = {
        start_at: this.event_info.start_at,
        register_by: this.event_info.register_by || null,
        location: this.event_info.location,
        external_registration: this.externalRegistration ? 1 : 0,
        external_registration_url: this.externalRegistration
          ? (this.event_info.external_registration_url || null)
          : null,
        toc: this.externalRegistration ? '' : this.event_info.toc,
        event_limit: this.externalRegistration ? null : Number(this.event_info.registrationLimit),
        user_limit: this.externalRegistration ? null : Number(this.event_info.userLimit),
        company_limit: this.externalRegistration ? null : Number(this.event_info.companyLimit),
        additional_fields: (!this.externalRegistration && this.show_select_field_type)
          ? normalizeAdditionalFieldsForApi(validAdditionalFields)
          : {} //if hidden, do not sent the values
      };

      formData.append("event", JSON.stringify(eventData));
      this.$refs.audienceTargeting.appendToEditFormData(formData, {
        initialLabelIds: this.initialLabelIds,
        initialGroupIds: this.initialGroupIds,
      });

      try {
          const response = await Content.editBusinessNews(this.news_id, formData);
          const errorMsg = response.data.error ? response.data.error : 'Update failed';

          if (response.data.data && !response.data.error) {
              this.successmsg("Business Event successfully updated");
              this.closeModal();
              this.refreshData();
          } else {
            //console.error("Update failed:", response.error);
            this.failedmsg(errorMsg);
          }
      } catch (error) {
          this.failedmsg(error.response.data.error);
      } finally {
          this.tryingToEdit = false;
      }
    },

    convertHtmlToJson(htmlContent) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, 'text/html');
      const articleContent = [];

      doc.body.childNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          articleContent.push({
            type: node.tagName.toLowerCase(),
            text: node.innerText
          });
        }
      });

      return JSON.stringify({
        articleContent: articleContent,
        articleLinks: [],
        articleImages: []
      });
    },
    isFutureDate(date) {
      const now = new Date();
      const selectedDate = new Date(date);
      return selectedDate > now;
    },

    refreshData() {
      this.$emit('onRefresh'); // event from parent
    },

    openDatePicker() {
      this.$refs.datePicker.$el.click();
    },

    openTimePicker() {
      this.$refs.timePicker.$el.click();
    },

    openPublishedDatePicker() {
      this.$refs.publishedDatePicker.$el.click();
    },

    openPublishedTimePicker() {
      this.$refs.publishedTimePicker.$el.click();
    },

    openRegisterByDatePicker() {
      this.$refs.registerByDatePicker.$el.click();
    },

    openRegisterByTimePicker() {
      this.$refs.registerByTimePicker.$el.click();
    },

    updateStartAt() {
      if (this.date && this.time) {
        this.event_info.start_at = `${this.date} ${this.time}`;
      } else if (this.date) {
        this.event_info.start_at = this.date;
      } else {
        this.event_info.start_at = '';
      }
    },

    updatePublished() {
      if (this.publishedDate && this.publishedTime) {
        this.published = `${this.publishedDate} ${this.publishedTime}`;
      } else if (this.publishedDate) {
        this.published = this.publishedDate;
      } else {
        this.published = '';
      }
    },

    updateRegisterBy() {
      if (this.registerByDate && this.registerByTime) {
        this.event_info.register_by = `${this.registerByDate} ${this.registerByTime}`;
      } else if (this.registerByDate) {
        this.event_info.register_by = this.registerByDate;
      } else {
        this.event_info.register_by = '';
      }
    },

    syncRegisterByWithEventDate() {
      this.registerByDate = this.date || '';
      this.registerByTime = this.time || '';
      this.updateRegisterBy();
    },

    splitDateTime(value) {
      if (!value) {
        return { date: '', time: '' };
      }

      const datetime = new Date(String(value).replace(' ', 'T'));
      if (isNaN(datetime.getTime())) {
        return { date: '', time: '' };
      }

      const year = datetime.getFullYear();
      const month = String(datetime.getMonth() + 1).padStart(2, '0');
      const day = String(datetime.getDate()).padStart(2, '0');
      const hours = String(datetime.getHours()).padStart(2, '0');
      const minutes = String(datetime.getMinutes()).padStart(2, '0');

      return {
        date: `${year}-${month}-${day}`,
        time: `${hours}:${minutes}`,
      };
    },

    triggerFileInput() {
      this.$refs['file-input'].click();
    },

    handleFileDrop(event) {
      this.isDragOver = false;
      const files = event.dataTransfer && event.dataTransfer.files;
      if (files && files.length > 0) {
        this.processFile(files[0]);
      }
    },

    processFile(file) {
      let bytes = file.size;
      let sizeInKB = bytes / 1024;
      const formatedKB = sizeInKB.toFixed(2);
      if (formatedKB > this.accepted_file_size) {
        this.acceptedFileSizeErrorMessage = 'File size too large | Maximum allowed size is ' + this.accepted_file_size + ' KB';
        this.acceptedFileSizeError = true;
      } else {
        this.acceptedFileSizeErrorMessage = '';
        this.acceptedFileSizeError = false;
      }
      if(!this.accepted_file_types.includes(file.type)) {
        this.acceptedFileTypeErrorMessage = 'File not accepted | Accepted formats are png, jpg, gif, bmp, webp';
        this.acceptedFileTypeError = true;
      } else {
        this.acceptedFileTypeErrorMessage = '';
        this.acceptedFileTypeError = false;
      }
      if (!this.acceptedFileTypeError && !this.acceptedFileSizeError) {
        this.file = file;
        if (this.image) {
          URL.revokeObjectURL(this.image);
        }
        this.image = URL.createObjectURL(file);
      }
    },

    selectFile(event) {
      const file = event.target.files && event.target.files[0];
      if (file) {
        this.processFile(file);
      }
    },
    removeImage() {
      this.file = null;
      if (this.image) {
        URL.revokeObjectURL(this.image);
      }
      this.image = "";
      if (this.$refs['file-input']) {
        this.$refs['file-input'].value = '';
      }
    },

    resetProps() {
      this.submitted = false;
      this.title = "";
      this.original_content = "";
      this.image = "";
      this.file = null;
      if (this.image) URL.revokeObjectURL(this.image);
      this.verified_checked = null;
      this.event_info = {
        start_at: '',
        register_by: '',
        registrationLimit: null,
        userLimit: null,
        companyLimit: null,
        location: '',
        toc: '',
        external_registration: 0,
        external_registration_url: '',
      };
      this.externalRegistration = false;
      this.date = '';
      this.time = '';
      this.registerByDate = '';
      this.registerByTime = '';
      this.isPopulatingFields = false;
      this.published = '';
      this.publishedDate = '';
      this.publishedTime = '';
      this.show_select_field_type = false,
      this.showCheckedIcon = false,
      this.showNotCheckedIcon = true,
      this.isDragOver = false,
      this.field_type = '',
      this.additional_field_options = [],
      this.sectionIdCounter = 0,
      this.additional_sections = [],
      this.savedSections = [],
      this.initialLabelIds = [],
      this.initialGroupIds = [],
      this.destroySortable();
      if (this.$refs.audienceTargeting) {
        this.$refs.audienceTargeting.reset();
      }
      if (this.$refs['file-input']) {
        this.$refs['file-input'].value = '';
      }
    },

     async fetchBusinessEventFieldsDefinition() {
       const response = await Content.getBusinessEventFieldsDefinition();
       this.fields_definition = response.data.data;
       this.additional_field_options = Object.keys(this.fields_definition).map(k => ({
         value: k,
         text: this.fields_definition[k].description
       }));
     },

     async getBusinessEventFieldsDefinition() {
       await this.fetchBusinessEventFieldsDefinition();
       this.show_select_field_type = true;
       this.showCheckedIcon = true;
       this.showNotCheckedIcon = false;
     },

     async ensureAdditionalFieldsReady() {
       // Load field-type options for the dropdown without inventing a blank required section
       if (!this.additional_field_options || this.additional_field_options.length === 0) {
         await this.fetchBusinessEventFieldsDefinition();
       }
       this.show_select_field_type = true;
       this.showCheckedIcon = true;
       this.showNotCheckedIcon = false;

       if (!Array.isArray(this.additional_sections)) {
         this.additional_sections = [];
       }
       if (!Array.isArray(this.savedSections)) {
         this.savedSections = [];
       }

       this.$nextTick(() => {
         this.initSortable();
       });
     },

     addSection() {
       const newSection = {
         _id: this.sectionIdCounter++,
         field_type: '',
         name: '',
         label: '',
         required: 0,
         field_attributes: {},
         field_id: ''
       };

       // Auto-select first field type if available
       if (this.additional_field_options && this.additional_field_options.length > 0) {
         newSection.field_type = this.additional_field_options[0].value;
       }

       this.additional_sections.push(newSection);

       // Initialize field attributes if field_type is set
       if (newSection.field_type) {
         this.onFieldTypeChange(newSection);
       }

       // Initialize savedSections entry
       this.savedSections.push(false);

       // touch validations after next tick
       this.$nextTick(() => {
         this.$v.additional_sections.$touch();
       });
     },

      removeSection(index) {
        this.additional_sections.splice(index, 1);
        // Also remove the corresponding savedSections entry
        if (this.savedSections[index] !== undefined) {
          this.savedSections.splice(index, 1);
        }
        // Reinit sortable after removing a section
        this.$nextTick(() => {
          this.destroySortable();
          this.initSortable();
          this.$v.additional_sections.$touch();
        });
     },

      addAdditionalFields(){
        this.show_select_field_type = !this.show_select_field_type;
        this.showCheckedIcon = !this.showCheckedIcon;
        this.showNotCheckedIcon = !this.showNotCheckedIcon;

        if (this.show_select_field_type) {
          this.getBusinessEventFieldsDefinition();

          if (this.additional_sections.length === 0) {
            this.additional_sections.push({
              _id: this.sectionIdCounter++,
              field_type: "",
              name: "",
              label: "",
              required: 0,
              field_attributes: {},
              field_id: ""
            });
            this.savedSections.push(false);
          }
        } else {
          this.additional_sections = [];
          this.savedSections = [];
          this.additional_field_options = [];
        }
      },

      addAdditionalField() {
         if (!this.field_type) return;
         const def = this.fields_definition[this.field_type];
         if (def && def.required_params) {
           const params = JSON.parse(def.required_params);
           const field_attributes = {};
           params.forEach(p => {
             field_attributes[p.param] = p.param_type === "array" ? [""] : "";
           });

           this.additional_fields.push({
             field_type: this.field_type,
             name: this.name,
             label: this.label,
             required:this.required,
             field_attributes,
             field_id: this.field_id
           });
         }
         // Reset selection so user can pick another type
         this.field_type = '';
         this.name = '';
         this.label = '';
         this.field_id='';
      },

       onFieldTypeChange(section) {
        const def = this.fields_definition[section.field_type];
        if (!def || !def.required_params) {
          section.field_attributes = null;
          return;
        }

        section.field_attributes = buildDefaultFieldAttributes(def);
      },

      detectInputType(section, key) {
          const def = this.fields_definition[section.field_type];
          return detectParamInputType(def, key);
        },

      getParamDescription(section, key) {
        //No section or no type picked yet
        if (!section || !section.field_type) return key;

        //Get the definition for this sections type
        const def = this.fields_definition[section.field_type];
        if (!def || !def.required_params) return key;

        //required_params is a JSON string from the API
        let params = [];
        try {
          params = JSON.parse(def.required_params || "[]");
        } catch (e) {
          return key;
        }

        //Find this params schema
        const spec = params.find(p => p.param === key);
        return spec && spec.description ? spec.description : key;
      },

      saveAdditionalField(index) {
        // Mark this section as saved
        this.$set(this.savedSections, index, true);
        // Reinit sortable after adding a saved section
        this.$nextTick(() => {
          this.destroySortable();
          this.initSortable();
        });
      },

      expandField(index) {
        // Set to false to show the form again (don't delete to maintain index alignment)
        this.$set(this.savedSections, index, false);
        // Reinit sortable after removing a saved section
        this.$nextTick(() => {
          this.destroySortable();
          this.initSortable();
        });
      },

      initSortable() {
        this.$nextTick(() => {
          const container = document.getElementById('additional-fields-container');
          if (container) {
            // Destroy existing instance if any
            if (this.sortableInstance) {
              this.sortableInstance.destroy();
            }
            
            this.sortableInstance = Sortable.create(container, {
              handle: '.drag-handle',
              animation: 150,
              ghostClass: 'sortable-ghost',
              filter: '.no-drag',
              preventOnFilter: false,
              onEnd: (evt) => {
                // Get the actual indices of saved sections in the original arrays
                const savedIndices = [];
                this.additional_sections.forEach((section, idx) => {
                  if (this.savedSections[idx]) {
                    savedIndices.push(idx);
                  }
                });
                
                // Only reorder if we dragged a saved section
                if (evt.oldIndex !== null && evt.newIndex !== null && 
                    evt.oldIndex < savedIndices.length && evt.newIndex < savedIndices.length) {
                  const oldRealIndex = savedIndices[evt.oldIndex];
                  const newRealIndex = savedIndices[evt.newIndex];
                  
                  // Rearrange the arrays directly
                  const movedSection = this.additional_sections.splice(oldRealIndex, 1)[0];
                  this.additional_sections.splice(newRealIndex, 0, movedSection);
                  
                  // Also rearrange savedSections
                  const movedSaved = this.savedSections.splice(oldRealIndex, 1)[0];
                  this.savedSections.splice(newRealIndex, 0, movedSaved);
                }
              }
            });
          }
        });
      },

      destroySortable() {
        if (this.sortableInstance) {
          this.sortableInstance.destroy();
          this.sortableInstance = null;
        }
      },

    async modalShown() {
      await this.populateFields();
      this.$nextTick(() => {
        this.initSortable();
      });
    },

    async populateFields() {
        if (this.data) {
            this.isPopulatingFields = true;
            try {
            this.news_id = this.data.id || "";
            this.title = this.data.title || "";
            this.original_content = this.data.original_content || "";
            this.image = this.data.image || "";
            this.event_info.start_at = this.data.event_info.start_at || "";
            
            const startAtParts = this.splitDateTime(this.event_info.start_at);
            this.date = startAtParts.date;
            this.time = startAtParts.time;
            const eventDate = this.date;

            const publishedParts = this.splitDateTime(this.data.published);
            this.publishedDate = publishedParts.date;
            this.publishedTime = publishedParts.time;
            this.updatePublished();
            
            this.event_info.location = this.data.event_info.location || "";
            this.event_info.toc = this.data.event_info.toc || "";
            this.event_info.registrationLimit = this.data.event_info.registrationLimit || "";
            this.event_info.userLimit = this.data.event_info.userLimit || "";
            this.event_info.companyLimit = this.data.event_info.companyLimit || "";
            const isExternal = !!(this.data.event_info && Number(this.data.event_info.external_registration));
            this.externalRegistration = isExternal;
            this.event_info.external_registration = isExternal ? 1 : 0;
            this.event_info.external_registration_url = (this.data.event_info && this.data.event_info.external_registration_url) || "";
            this.verified_checked = this.data.active || "";

            const labels = Array.isArray(this.data.labels) ? this.data.labels : [];
            const groups = Array.isArray(this.data.groups) ? this.data.groups : [];
            this.initialLabelIds = labels.map((label) => Number(label.id));
            this.initialGroupIds = groups.map((group) => String(group.group_id));
            this.$nextTick(async () => {
              if (this.$refs.audienceTargeting) {
                await this.$refs.audienceTargeting.onShown();
                await this.$refs.audienceTargeting.loadFromInitialAudience({
                  labels,
                  groups,
                  audience_type: this.data.audience_type || '',
                  audience_operator: this.data.audience_operator || 'OR',
                });
              }
            });

            if (Array.isArray(this.data.event_info.event_fields) && this.data.event_info.event_fields.length > 0) {
                this.show_select_field_type = true;
                await this.getBusinessEventFieldsDefinition();

                this.additional_sections = this.data.event_info.event_fields.map((f, idx) => {
                const attrs = {};
                if (f.attributes && typeof f.attributes === 'object') {
                     Object.keys(f.attributes).forEach(attrKey => {
                       attrs[attrKey] = f.attributes[attrKey] || '';
                     });
                }

                  return {
                    _id: idx,
                    field_id: f?.id || '',
                    field_type: f?.input_type || '',
                    name: f?.name || '',
                    label: f?.label || '',
                    required: f?.is_required ? 1 : 0,
                    field_attributes: attrs

                  }
                });
                
                // Mark all existing fields as saved
                this.savedSections = this.additional_sections.map(() => true);
                
                // Update sectionIdCounter to avoid conflicts
                if (this.additional_sections.length > 0) {
                  this.sectionIdCounter = Math.max(...this.additional_sections.map(s => s._id)) + 1;
                }
            } else if (!isExternal) {
                // No custom fields yet — load definitions for "Add Field", but do not
                // invent an empty required section that blocks save.
                this.additional_sections = [];
                this.savedSections = [];
                this.sectionIdCounter = 0;
                await this.ensureAdditionalFieldsReady();
            } else {
                this.additional_sections = [];
                this.savedSections = [];
                this.sectionIdCounter = 0;
                this.show_select_field_type = false;
                this.showCheckedIcon = false;
                this.showNotCheckedIcon = true;
            }

            const registerByRaw =
              (this.data.event_info && this.data.event_info.register_by) ||
              this.data.register_by ||
              '';
            let registerByDate = '';
            let registerByTime = '';
            if (registerByRaw) {
              const registerByStr = String(registerByRaw).trim();
              registerByDate = registerByStr.slice(0, 10);
              const timePart = registerByStr.length > 10 ? registerByStr.slice(11, 16) : '';
              registerByTime = timePart || (this.time || '');
            } else {
              registerByDate = eventDate || '';
              registerByTime = this.time || '';
            }
            if (eventDate && registerByDate > eventDate) {
              registerByDate = eventDate;
              registerByTime = this.time || registerByTime;
            }

            await this.$nextTick();
            this.registerByDate = registerByDate;
            this.registerByTime = registerByTime;
            this.updateRegisterBy();
            } finally {
              await this.$nextTick();
              this.isPopulatingFields = false;
            }
        }
    },

    closeModal() {
      this.showModal = false;
      this.resetProps();
    },

    successmsg() {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Change has been saved",
        showConfirmButton: false,
        timer: 2000,
      });
    },

    failedmsg(msg,title = "Error") {
      Swal.fire({
        position: "center",
        icon: "error",
        title: msg,
        showConfirmButton: false,
        timer: 5000,
      });
    },
  }
};

</script>

<template>
  <b-modal
      id="event_edit"
      size="lg"
      v-model="showModal"
      :data="data"
      @hidden="resetProps"
      @shown="modalShown"
      title-class="font-18"
      no-enforce-focus
  >
    <template v-slot:modal-header>
      <div class="w-100">
        <h5 class="modal-title mb-0">Edit Business Event</h5>
        <p class="text-muted mb-0 mt-2">Update event details for your business club members</p>
      </div>
      <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
    </template>
    <form @submit.prevent="editBusinessEvent">
        <div class="card mb-3">
          <div class="card-body py-2">
            <h4 class="card-title mb-1">Basic Information</h4>
            <p class="text-muted mb-3">Essential details about your event</p>
            <div class="form-check form-switch form-switch-lg mb-3">
              <label class="form-check-label" for="newsStatus">Active</label>
              <input v-model="verified_checked"
                     type="checkbox"
                     class="form-check-input"
                     id="newsStatus"
              />
            </div>
            <div class="mb-2">
              <label class="mb-1">Event Name *</label>
              <b-form-input v-model="title" placeholder="e.g., Executive Networking Dinner"></b-form-input>
            </div>
            <validationMessages 
                  v-if="submitted"
                  :fieldName="'Event Name'"
                  :validationName="$v.title">
            </validationMessages>
            <div class="row mb-2">
              <div class="col-md-4">
                <label class="mb-1"> <i class="uil uil-map-marker me-1"></i>Location * </label>
                <b-form-input v-model="event_info.location" placeholder="e.g., Stadium VIP Lounge"></b-form-input>
              </div>
              <div class="col-md-4">
                <label class="mb-1">
                  <i class="uil uil-calendar-alt me-1"></i>Date *
                </label>
                <div class="position-relative">
                  <flat-pickr
                    ref="datePicker"
                    v-model="date"
                    :config="dateconfig"
                    class="form-control pe-4"
                    name="date"
                  />
                  <i class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted" 
                     style="cursor: pointer; pointer-events: all;"
                     @click="openDatePicker"></i>
                </div>
              </div>

              <div class="col-md-4">
                <label class="mb-1">
                  <i class="uil uil-clock me-1"></i>Time *
                </label>
                <div class="position-relative">
                  <flat-pickr
                    ref="timePicker"
                    v-model="time"
                    :config="timeconfig"
                    class="form-control pe-4"
                    name="time"
                  />
                  <i class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted" 
                     style="cursor: pointer; pointer-events: all;"
                     @click="openTimePicker"></i>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4">
                <label class="mb-1">
                  <i class="uil uil-calendar-alt me-1"></i>Published Date *
                </label>
                  <div class="position-relative">
                    <flat-pickr
                      ref="publishedDatePicker"
                      v-model="publishedDate"
                      :config="publishedDateconfig"
                      class="form-control pe-4"
                      name="publishedDate"
                    />
                    <i
                      class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                      style="cursor: pointer; pointer-events: all;"
                      @click="openPublishedDatePicker"
                    ></i>
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="mb-1">
                    <i class="uil uil-clock me-1"></i>Published Time *
                  </label>
                  <div class="position-relative">
                    <flat-pickr
                      ref="publishedTimePicker"
                      v-model="publishedTime"
                      :config="publishedTimeconfig"
                      class="form-control pe-4"
                      name="publishedTime"
                    />
                    <i
                      class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                      style="cursor: pointer; pointer-events: all;"
                      @click="openPublishedTimePicker"
                    ></i>
                  </div>
                </div>
              </div>
            <validationMessages
                  v-if="submitted"
                  :fieldName="'Location'"
                  :validationName="$v.event_info.location">
            </validationMessages>
            <validationMessages
              v-if="submitted"
              :fieldName="'Date and Time'"
              :validationName="$v.event_info.start_at"
            ></validationMessages>
            <validationMessages
              v-if="submitted"
              :fieldName="'Published Date'"
              :validationName="$v.published"
            ></validationMessages>
          </div>
        </div>
        <div class="card mb-3">
          <div class="card-body py-2">
            <h4 class="card-title mb-1">
              <i class="uil uil-image me-2"></i>Header Image
            </h4>
            <p class="text-muted mb-3">Upload a banner image for the event page (recommended: 1200x400px)</p>
            <b-form-group label-for="image" class="mb-3">
              <!-- Image Preview -->
              <div v-if="image" class="mb-3">
                <div class="image-preview-container position-relative" style="width: 100%; min-height: 200px; background: #f8f9fa; border-radius: 8px; overflow: hidden;">
                  <img :src="image" alt="Preview" style="width: 100%; height: 100%; object-fit: cover;">
                  
                  <!-- Text Overlay (Bottom Left) -->
                  <div class="position-absolute" style="bottom: 15px; left: 15px; background: rgba(0,0,0,0.6); color: white; padding: 8px 12px; border-radius: 4px;">
                    <div style="font-size: 14px; font-weight: 600; margin-bottom: 2px;">Header Image Preview</div>
                    <div style="font-size: 12px; opacity: 0.9;">This is how your image will appear</div>
                  </div>
                  
                  <!-- Remove Button (Bottom Right) -->
                  <button 
                    type="button" 
                    @click="removeImage" 
                    class="btn btn-sm position-absolute"
                    style="bottom: 15px; right: 15px; background: rgba(255,255,255,0.95); border: 1px solid #dee2e6; color: #495057; font-size: 12px; padding: 4px 12px; display: flex; align-items: center;"
                  >
                    <i class="uil uil-times me-1"></i>Remove
                  </button>
                </div>
              </div>
              
              <!-- Upload Area -->
              <div 
                v-if="!image"
                class="upload-area text-center position-relative"
                :class="{'border-primary': isDragOver}"
                @dragover.prevent="isDragOver = true"
                @dragleave.prevent="isDragOver = false"
                @drop.prevent="handleFileDrop"
                style="
                  cursor: pointer;
                  min-height: 220px;
                  display: flex; flex-direction: column; justify-content: center; align-items: center;
                  border: 2px dashed #cbd5e1;
                  border-radius: 12px;
                  padding: 28px;
                  background: #fff;
                "
                @click="triggerFileInput"
              >
                <div style="
                  width: 72px; height: 72px; border-radius: 9999px;
                  background: #eef2ff; display: flex; align-items: center; justify-content: center;
                  margin-bottom: 12px;
                ">
                  <i class="uil uil-upload" style="font-size: 28px; color: #6b7280;"></i>
                </div>
                <div class="mb-1" style="font-weight: 500; color: #111827;">
                  Drag and drop an image, or click to browse
                </div>
                <div class="text-muted mb-3" style="font-size: 13px;">
                  PNG, JPG up to 10MB
                </div>
                <button type="button" class="btn btn-light btn-sm" @click.stop="triggerFileInput">
                  <i class="uil uil-upload me-1"></i>
                  Choose File
                </button>
                <input 
                  ref="file-input" 
                  type="file" 
                  @change="selectFile" 
                  accept="image/*" 
                  style="display: none;"
                />
              </div>
              <p v-if="acceptedFileTypeError" class="text-danger mt-2">{{acceptedFileTypeErrorMessage}}</p>
              <p v-if="acceptedFileSizeError" class="text-danger">{{acceptedFileSizeErrorMessage}}</p>
            </b-form-group>
          </div>
        </div>

          <div class="card mb-3">
            <div class="card-body py-2">
              <h4 class="card-title mb-1">
                <i class="uil uil-ticket me-2"></i>Registration Type
              </h4>
              <p class="text-muted mb-3">Choose how attendees register for this event</p>
              <div class="d-flex align-items-center flex-wrap mb-3" style="gap: 12px;">
                <span
                  class="mb-0"
                  :style="{ fontWeight: externalRegistration ? 400 : 600, color: externalRegistration ? '#6c757d' : '#212529' }"
                >
                  App Registration
                </span>
                <div class="form-check form-switch form-switch-lg mb-0">
                  <input
                    id="editExternalRegistrationSwitch"
                    v-model="externalRegistration"
                    type="checkbox"
                    class="form-check-input"
                  />
                </div>
                <span
                  class="mb-0"
                  :style="{ fontWeight: externalRegistration ? 600 : 400, color: externalRegistration ? '#212529' : '#6c757d' }"
                >
                  External Registration
                </span>
              </div>
              <div v-if="externalRegistration">
                <b-form-group label-for="editExternalRegistrationUrl" class="mb-0">
                  <template v-slot:label>
                    <i class="uil uil-link me-1"></i> External Registration URL *
                  </template>
                  <b-form-input
                    id="editExternalRegistrationUrl"
                    v-model="event_info.external_registration_url"
                    type="url"
                    placeholder="https://example.com/register"
                  ></b-form-input>
                  <small class="text-muted">Users will be redirected to this URL to register</small>
                  <validationMessages
                    v-if="submitted"
                    :fieldName="'External Registration URL'"
                    :validationName="$v.event_info.external_registration_url">
                  </validationMessages>
                </b-form-group>
              </div>
            </div>
          </div>

          <div v-if="!externalRegistration" class="card mb-3">
                <div class="card-body py-2">
                    <h4 class="card-title mb-1">  <i class="uil uil-users-alt me-2"></i>Capacity & Limits</h4>
                    <p class="text-muted mb-3">Set attendance restrictions for the event</p>
                    <div class="row">
                        <div class="col-md-4">
                          <b-form-group label-for="userLimit" class="mb-3">
                            <template v-slot:label>
                              <i class="uil uil-users-alt me-1"></i> Max per user
                            </template>
                            <b-form-input v-model="event_info.userLimit" placeholder="1"></b-form-input>
                            <small class="text-muted">Tickets per person</small>
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group label-for="companyLimit" class="mb-3">
                            <template v-slot:label>
                              <i class="uil uil-building me-1"></i> Max per Company
                            </template>
                            <b-form-input v-model="event_info.companyLimit" placeholder="10"></b-form-input>
                            <small class="text-muted">Tickets per company</small>
                            </b-form-group>
                        </div>
                        <div class="col-md-4">
                          <b-form-group label-for="eventLimit" class="mb-3">
                            <template v-slot:label>
                              <i class="uil uil-users-alt me-1"></i> Total Capacity
                            </template>
                            <b-form-input v-model="event_info.registrationLimit" placeholder="100"></b-form-input>
                            <small class="text-muted">Maximum attendees</small>
                            <validationMessages
                                v-if="submitted"
                                :fieldName="'Event Limit'"
                                :validationName="$v.event_info.registrationLimit">
                            </validationMessages>
                         </b-form-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                          <label class="mb-1">
                            <i class="uil uil-calendar-alt me-1"></i>Register By Date
                          </label>
                          <div class="position-relative">
                            <flat-pickr
                              :key="'register-by-' + registerByDate + '-' + date"
                              ref="registerByDatePicker"
                              v-model="registerByDate"
                              :config="registerByDateConfig"
                              class="form-control pe-4"
                              name="register_by_date"
                            />
                            <i class="uil uil-calendar-alt position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                               style="cursor: pointer; pointer-events: all;"
                               @click="openRegisterByDatePicker"></i>
                          </div>
                          <small class="text-muted">Deadline for registration</small>
                        </div>
                        <div class="col-md-4">
                          <label class="mb-1">
                            <i class="uil uil-clock me-1"></i>Register By Time
                          </label>
                          <div class="position-relative">
                            <flat-pickr
                              :key="'register-by-time-' + registerByTime"
                              ref="registerByTimePicker"
                              v-model="registerByTime"
                              :config="timeconfig"
                              class="form-control pe-4"
                              name="register_by_time"
                            />
                            <i class="uil uil-clock position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
                               style="cursor: pointer; pointer-events: all;"
                               @click="openRegisterByTimePicker"></i>
                          </div>
                        </div>
                    </div>
                </div>
           </div>

          <BusinessNewsAudienceTargeting ref="audienceTargeting" entity-label="business event" />

        <div v-if="!externalRegistration" class="card mb-3">
          <div class="card-body py-2">
            <h4 class="card-title mb-1">Additional Information Fields</h4>
            <p class="text-muted mb-3">Collect custom information from attendees during registration</p>
        <div id="additional-fields-container">
             <div v-for="(section, index) in additional_sections" :key="section._id" class="mb-3">
               <!-- Saved compact view -->
               <div v-if="savedSections[index]" class="card border saved-field">
                 <div class="card-body p-3 d-flex align-items-center">
                   <div class="drag-handle me-3" style="cursor: move;">
                     <i class="uil uil-bars" style="font-size: 18px; color: #6c757d;"></i>
                   </div>
                   <div class="flex-grow-1 font-weight-bold">{{ section.label || 'Untitled Field' }}</div>
                   <button type="button" class="btn btn-sm btn-light" @click="expandField(index)">
                     <i class="uil uil-edit me-1"></i>Edit
                   </button>
                   <button type="button" class="btn btn-sm btn-danger ms-2" @click="removeSection(index)">
                     <i class="uil uil-trash-alt"></i>
                   </button>
                 </div>
               </div>

               <!-- Expanded edit form -->
               <div v-else class="no-drag p-3 rounded mb-3" style="border: 1px solid #dee2e6; background-color: #fff;">
                 <div class="row">
                   <div class="col-md-6">
                     <b-form-group label="Field Label *">
                       <b-form-input v-model="section.label" placeholder="e.g., Dietary Requirements" />
                       <validationMessages
                         v-if="submitted && $v.additional_sections.$each && $v.additional_sections.$each[index]"
                         :fieldName="'Label'"
                         :validationName="$v.additional_sections.$each[index].label"
                       />
                     </b-form-group>
                   </div>

                   <div class="col-md-6">
                     <b-form-group label="Field Type">
                       <div class="d-flex gap-2">
                     <b-form-select
                       v-model="section.field_type"
                       :options="additional_field_options"
                       @change="onFieldTypeChange(section)"
                           class="flex-grow-1"
                           :disabled="!additional_field_options || additional_field_options.length === 0"
                         >
                           <template #first>
                             <option :value="null" disabled>Select field type...</option>
                           </template>
                         </b-form-select>

                       </div>
                     <validationMessages
                         v-if="submitted && $v.additional_sections.$each && $v.additional_sections.$each[index] && $v.additional_sections.$each[index].field_type"
                         :fieldName="'Field Type'"
                         :validationName="$v.additional_sections.$each[index].field_type"
                     />
                     </b-form-group>
                   </div>

                   <div class="col-md-12">
                   <!-- Dynamic Params -->
                   <div v-if="section.field_attributes">
                    <div v-for="(value, key) in section.field_attributes" :key="key">
                      <input v-if="key === 'rows'" type="hidden" v-model="section.field_attributes[key]" />
                      <b-form-group v-else :label="getParamDescription(section, key)" class="mb-3">
                         <!-- Array values -->
                         <div v-if="Array.isArray(value)">
                           <div v-for="(opt, i) in value" :key="i" class="d-flex mb-2">
                             <b-form-input
                               v-model="section.field_attributes[key][i]"
                               placeholder="Enter option"
                             />
                             <b-button
                               v-if="section.field_attributes[key].length > 1"
                               size="sm"
                               variant="danger"
                               class="ml-2"
                               @click="section.field_attributes[key].splice(i,1)"
                             >  <i class="uil uil-trash-alt"></i>
                             </b-button>
                           </div>
                           <b-button size="sm" variant="success" @click="section.field_attributes[key].push('')">
                             <i class="mdi mdi-plus me-2"></i> Add option
                           </b-button>
                         </div>

                         <!-- Single value -->
                         <div v-else>
                           <b-form-input
                             v-model="section.field_attributes[key]"
                             :type="detectInputType(section, key)"
                               :placeholder="key === 'placeholder' ? 'Helper text for users...' : ''"
                           />
                         </div>
                       </b-form-group>
                       </div>
                     </div>

                     <div class="d-flex align-items-center justify-content-between">
                       <b-form-checkbox-group>
                         <span class="ms-2">Required field</span>
                         <div class="form-check form-switch form-switch-lg mb-0">
                           <input
                             v-model="section.required"
                             type="checkbox"
                             class="form-check-input"
                             :true-value="1"
                             :false-value="0"
                           />
                         </div>
                       </b-form-checkbox-group>
                       <button type="button" class="btn btn-primary" @click="saveAdditionalField(index)">
                         <i class="uil uil-check"></i> Save
                       </button>
                     </div>
                   </div>
                 </div>
                     </div>
                   </div>
                </div>

                 <!-- Add new section -->
                 <div class="row mt-2">
                    <div class="col-12">
                        <button 
                          type="button" 
                          class="btn" 
                          @click="addSection"
                          style="
                            background: #f8f9fa;
                            border: 1px dashed #dee2e6;
                            color: #495057;
                            border-radius: 6px;
                            padding: 8px 16px;
                            transition: background-color 0.2s;
                            width: 100%;
                            display: block;
                            text-align: center;
                          "
                          @mouseenter="$event.target.style.background = '#e9ecef'"
                          @mouseleave="$event.target.style.background = '#f8f9fa'"
                        >
                          <i class="uil uil-plus me-1"></i>Add New Field
                        </button>
                    </div>
                 </div>

                 <!-- Tip banner -->
                 <div class="mt-3 p-3 rounded" style="background-color: #e3f2fd; border: 1px solid #90caf9;">
                   <div class="d-flex align-items-center">
                     <i class="uil uil-lightbulb-alt me-2" style="color: #fdd835; font-size: 20px;"></i>
                     <div>
                       <strong style="color: #1976d2;">Tip:</strong>
                       <span style="color: #1976d2;"> Fields will appear in this order during event registration. Drag to reorder.</span>
                     </div>
                   </div>
                 </div>
            </div>
        </div>

        <div v-if="!externalRegistration" class="card mb-3">
          <div class="card-body py-2">
            <h4 class="card-title mb-1">
              <i class="uil uil-file-alt me-2"></i>Terms & Conditions
            </h4>
            <p class="text-muted mb-3">Link to event terms and conditions</p>
            <b-form-group label="Terms & conditions URL" label-for="toc" class="mb-3">
              <b-form-input v-model="event_info.toc"></b-form-input>
              <small class="text-muted">Attendees will be required to accept these terms during registration</small>
            </b-form-group>
          </div>
        </div>

        <div class="row">
            <b-form-group label="Description" label-for="description" class="mb-3">
                <template>
                    <ckeditor :editor="editor" v-model="original_content" :config="editorConfig"></ckeditor>
                </template>
                <validationMessages
                        v-if="submitted"
                        :fieldName="'Description'"
                        :validationName="$v.original_content">
                </validationMessages>
            </b-form-group>
        </div>

      <input type="hidden" name="content_type" v-model="content_type" />
      <input type="hidden" name="csrf_token" v-model="csrf_token" />

       <!-- Validation summary -->
      <div v-if="submitted && validationErrors.length" class="alert alert-danger mt-3">
        <ul>
          <li v-for="(error, i) in validationErrors" :key="i">{{ error }}</li>
        </ul>
      </div>
      <br>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="editBusinessEvent" :disabled="tryingToEdit">
        <b-spinner v-show="tryingToEdit" small></b-spinner>
        Submit
      </b-button>
    </template>
  </b-modal>
</template>

<style scoped>
.sortable-ghost {
  opacity: 0.5;
}
</style>